<!-- 口袋精灵 -->
<template>
  <div class="container">
    <div class="header">
      <p class="header-text">hi，欢迎来到口袋精灵的世界。口袋精灵是一只只可爱的播放玩具设备，可以配合口袋故事使用，释放你的手机，给宝贝更好的体验。</p>
    </div>

    <div class="my-fairy" v-if="isLogin">
      <div class="my-menu" @click="goMySpirit">
        <div class="text">我的口袋精灵</div>
        <div class="guide" v-if="!deviceTotal">未绑定<img src="@/assets/spirit/arrow-enter.png" class="arrow-enter"></div>
        <div class="guide" v-else>已绑定{{deviceTotal}}台<img src="@/assets/spirit/arrow-enter.png" class="arrow-enter"></div>
      </div>
    </div>

    <div class="list">
      <div class="list-box">
        <div class="item" v-for="(item, index) in list" :key="item.f_id" @click="showMask(index)">
          <div class="pic-box">
            <img :src="item.f_good_img" alt="" class="item-pic">
            <transition name="slideup">
              <div class="pic-box-mask" :class="item.maskLayout" v-if="item.showMask">
                <template v-if="item.maskLayout === 'layout1'">
                  <div class="mask-item top-left" @click.stop="goDetail(item.f_desc_url)">
                    <img src="@/assets/spirit/detail.png" alt="" class="mask-icon">
                    <span class="mask-item-text">查看详情</span>
                  </div>
                  <div class="mask-item top-right" @click.stop="goBuy(item.f_good_url)">
                    <img src="@/assets/spirit/cart.png" alt="" class="mask-icon">
                    <span class="mask-item-text">购买精灵</span>
                  </div>
                  <div class="mask-item bottom" @click.stop="goBind(item.f_bind_url, item.f_id)">
                    <img src="@/assets/spirit/spirit.png" alt="" class="mask-icon">
                    <span class="mask-item-text">绑定口袋故事</span>
                  </div>
                </template>
                <template v-if="item.maskLayout === 'layout2'">
                  <div class="mask-item top" @click.stop="goDetail(item.f_desc_url)">
                    <img src="@/assets/spirit/detail.png" alt="" class="mask-icon">
                    <span class="mask-item-text">查看详情</span>
                  </div>
                  <div class="mask-item bottom" @click.stop="goBuy(item.f_good_url)">
                    <img src="@/assets/spirit/cart.png" alt="" class="mask-icon">
                    <span class="mask-item-text">购买精灵</span>
                  </div>
                </template>
                <template v-if="item.maskLayout === 'layout3'">
                  <div class="mask-item top" @click.stop="goBuy(item.f_good_url)">
                    <img src="@/assets/spirit/detail.png" alt="" class="mask-icon">
                    <span class="mask-item-text">购买精灵</span>
                  </div>
                  <div class="mask-item bottom" @click.stop="goBind(item.f_bind_url, item.f_id)">
                    <img src="@/assets/spirit/spirit.png" alt="" class="mask-icon">
                    <span class="mask-item-text">绑定口袋故事</span>
                  </div>
                </template>
                <template v-if="item.maskLayout === 'layout4'">
                  <div class="mask-item full" @click.stop="goBuy(item.f_good_url)">
                    <img src="@/assets/spirit/cart.png" alt="" class="mask-icon">
                    <span class="mask-item-text">购买精灵</span>
                  </div>
                </template>
              </div>
            </transition>
          </div>
          <div class="info">
            <h1 class="title">{{item.f_name}}</h1>
            <h2 class="subtitle">{{item.f_desc}}<img src="@/assets/spirit/arrow.png" alt="" class="arrow" :class="{'active': item.showMask}"></h2>
          </div>
        </div>
      </div>
    </div>

    <div class="footer" v-if="!isLogin">
      <div class="login-btn" @click="doLogin">已有口袋精灵？请立即登录</div>
    </div>
  </div>
</template>

<script>
import { login } from '@/utils/login'
import { getFairyList, getFairyDeviceList } from '@/apiv4/fairy'
import { throttle } from 'lodash'
export default {
  components: {  },
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
      size: 10,
      deviceList: [], // 已绑定的设备列表
      deviceTotal: 0,
      isLogin: this.$store.getters.token,
      kouDaiYouXuanMiniId: 'gh_0a89157a3fdb'
    }
  },
  async created() {
    if (this.$store.getters.token) {
      this.getFairyDeviceList()
    }
    await this.getFairyList(this.page, this.size)
    this.setMaskLayout()
  },
  mounted() {
    document.addEventListener('scroll', this.throttleGetFairyList(), false)
  },
  methods: {
    async getFairyList(page, size) {
      let fairyListRes = await getFairyList(page, size)
      let list = fairyListRes.data.list
      this.total = +fairyListRes.data.total
      this.page++
      this.list = this.list.concat(list)
    },
    async getFairyDeviceList() {
      let fairyListRes = await getFairyDeviceList()
      let list = fairyListRes.data.list
      this.deviceList = fairyListRes
      this.deviceTotal = +fairyListRes.data.total
    },
    throttleGetFairyList() {
      return throttle(async () => {
        const scrollHeight = $(document).height()
        const clientHeight = $(window).height()
        const scrollTop = $(document).scrollTop()
        if (clientHeight + scrollTop >= scrollHeight - 100 && this.list.length < this.total) {
          await this.getFairyList(this.page, this.size)
          this.setMaskLayout()
        }
      }, 100, { leading: true, trailing: false })
    },
    setMaskLayout() {
      let list = this.list
      let style = ''
      list.map(item => {
        if (item.f_desc_url) {
          if (item.f_bind_url) {
            // 有说明，有绑定，有购买
            style = 'layout1'
          } else {
            // 有说明，无绑定，有购买
            style = 'layout2'
          }
        } else {
          if (item.f_bind_url) {
            // 有绑定，有购买
            style = 'layout3'
          } else {
            // 只有购买
            style = 'layout4'
          }
        }
        item.maskLayout = style
        return item
      })
      this.list = list
    },
    showMask(index) {
      this.$set(this.list[index], 'showMask', !this.list[index].showMask)
    },
    goMySpirit() {
      if (!this.deviceTotal) return
      this.$router.push({ path: 'myspirit' })
    },
    goDetail(url) {
      let canOpen = this.canOpenInApp(url)
      if (canOpen) {
        window.location.href = url
      } else {
        let miniUrl = `ilisten:///openmp?username=${this.kouDaiYouXuanMiniId}&path=${encodeURIComponent(url)}`
        window.location.href = miniUrl
      }
    },
    goBuy(url) {
      let canOpen = this.canOpenInApp(url)
      if (canOpen) {
        window.location.href = url
      } else {
        let miniUrl = `ilisten:///openmp?username=${this.kouDaiYouXuanMiniId}&path=${encodeURIComponent(url)}`
        window.location.href = miniUrl
      }
    },
    goBind(url, fId) {
      url += `?fid=${fId}`
      // 这里没有考虑url中已经有query的情况
      window.location.href = url
    },
    doLogin() {
      login(window.location.href)
    },
    canOpenInApp(url) {
      let regRule = /^(http|https|ilisten):\/\//i
      return regRule.test(url)
    }
  }

}
</script>

<style scoped lang="less">
@import "~@/styles/fn";
.container {
  height: 100%;
  min-height: 100vh;
  background: #f4f4f8;
}

.header {
  margin-bottom: 2.4vw;
  width: 100%;
  background: #fff;
  &-text {
    padding: 4.53vw 4vw;
    text-align: justify;
    font-size: 3.74vw;
    color: #717171;
  }
}

.my-fairy {
  position: relative;
  margin-bottom: 2.4vw;
  padding: 0 4vw;
  padding-right: 8vw;
  background: #fff;
  height: 12.8vw;
  .my-menu {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    .text {
      color: #604038;
      font-size: 4.26vw;
    }
    .guide {
      position: relative;
      font-size: 4vw;
      color: #9b9b9b;
      .arrow-enter {
        display: block;
        position: absolute;
        right: -4vw;
        top: 50%;
        transform: translateY(-50%);
        width: 2.13vw;
        height: 4.26vw;
      }
    }
  }
}

.list {
  padding-bottom: 18.66vw;
  &-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 2.4vw;
    .item {
      position: relative;
      margin-bottom: 2.93vw;
      width: 46.13vw;
      height: 60.53vw;
      background: #fff;
      box-shadow: 0 1px 3px #c8c8c8;
      .pic-box {
        position: relative;
        width: 46.13vw;
        height: 46.13vw;
        overflow: hidden;
        &-mask {
          position: absolute;
          display: flex;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          z-index: 2;
          flex-wrap: wrap;
          .mask-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: rgba(44,42,62,0.48);
            color: #fff;
            font-size: 3.5vw;
            .mask-icon {
              display: block;
              width: 7.6vw;
              height: 7.6vw;
            }
          }
          .full {
            width: 100%;
            height: 100%;
          }
          .top {
            width: 100%;
            height: 50%;
          }
          .top-left, .top-right {
            width: 50%;
            height: 50%;
          }
          .top-left {
            border-right: 1px solid rgba(255,255,255,0.38);
          }
          .top-right {
            border-left: 1px solid transparent;
          }
          .bottom {
            width: 100%;
            height: 50%;
            border-top: 1px solid rgba(255,255,255,0.38);
          }
        }
        .layout1 {

        }
      }
      &-pic {
        width: 100%;
        height: 100%;
      }
      .info {
        position: relative;
        padding: 1.6vw 2.66vw;
        .title {
          position: relative;
          font-size: 3.73vw;
          font-weight: normal;
          color: #000;
          .ellipsis(100%);
        }
        .subtitle {
          position: relative;
          margin-top: 0.53vw;
          font-size: 3.2vw;
          font-weight: normal;
          color: #9b9b9b;
          .ellipsis(100%);
          .active {
            transform: translateY(-50%) rotate(180deg);
          }
        }
        .arrow {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          transition: all 0.3s ease;
          width: 3.46vw;
          height: 3.46vw;
        }
      }
    }
  }
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  height: 18.66vw;
  .login-btn {
    display: block;
    width: 92vw;
    height: 11.73vw;
    line-height: 11.73vw;
    text-align: center;
    color: #604038;
    font-size: 4.26vw;
    font-weight: bold;
    background-image: linear-gradient(-134deg, #feb800, #f8dd61);
    border-radius: 1vw;
    box-shadow: 1px 1px 5px #c3c3c3;
  }
}

.slideup-enter-active, .slideup-leave-active {
  transition: all .3s ease;
}

.slideup-enter, .slideup-leave-to {
  transform: translateY(46.13vw);
}

</style>
